import React from 'react';
import PageTitle from '../../Shared/PageTitle/PageTitle';

const About = () => {
    return (
        <div className='h-[90vh]'>
            <PageTitle title={'About'}></PageTitle>
           <h1 className='text-xl my-10'>Future I added</h1> 
        </div>
    );
};

export default About;